import React, { useCallback } from "react";
import { Field, Filter, RangePicker, Text, TimePicker } from "components/commons";
import lang from "translations";
import { modifyFromTimeRange, modifyToTimeRange } from "services";

const PreAuthTransactionFilter = ({
  filterState,
  modifyFilter,
  clearFilter,
  applyFilter,
}) => {
  const changeDateRangeCb = useCallback(
    (name, value) => {
      modifyFilter(name, { value });
    },
    [modifyFilter]
  );

  const clearFilterCb = useCallback(() => {
    clearFilter();
  }, [clearFilter]);

  return (
    <Filter
      placeholder={lang.searchGuestsBalanceMovements}
      className="my-lg"
      filterState={filterState}
      onApply={applyFilter}
      onClear={clearFilterCb}
      actionsSpan={12}
    >
      <Field filterLabel={lang.date} className="col-span-4">
        <RangePicker name="dateRange" value={filterState.dateRange} onChange={changeDateRangeCb} />
      </Field>
      <Field filterLabel={lang.timeRange} className="col-span-4">
        <div className="flex items-center">
          <TimePicker
            value={filterState.dateRange[0]}
            onChange={(val) => {
                modifyFromTimeRange(val, filterState, modifyFilter);
              }}
          />
          <Text className="mx-sm" color="text-black-light">
            {lang.to}
          </Text>
          <TimePicker
            value={filterState.dateRange[1]}
            onChange={(val) => {
                modifyToTimeRange(val, filterState, modifyFilter);
              }}
          />
        </div>
      </Field>
    </Filter>
  );
};

export default PreAuthTransactionFilter;
